import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';

import {
  AllocationViewCallToSecurityCheckAction,
  AllocationViewCallToSecurityCheckActionSetInitialState,
} from './allocation-view-call-to-arrival-security-action.actions';
import { AllocationViewCallToArrivalSecurityActionService } from './allocation-view-call-to-arrival-security-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewCallToArrivalSecurityActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewCallToArrivalSecurityActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsCallToArrivalSecurity',
  defaults: initialState,
})
@Injectable()
export class AllocationViewCallToArrivalSecurityActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewCallToArrivalSecurityActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewCallToArrivalSecurityActionService: AllocationViewCallToArrivalSecurityActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewCallToSecurityCheckAction)
  callToArrivalSecurityCheck(
    ctx: StateContext<AllocationViewCallToArrivalSecurityActionStateModel>,
    { payload: { identifier } }: AllocationViewCallToSecurityCheckAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewCallToArrivalSecurityActionService.callToArrivalSecurityCheck(identifier).pipe(
      map(() => {
        this.finishAction('api.uli.success.calledToSecurity');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewCallToSecurityCheckActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewCallToArrivalSecurityActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
